module.exports = __webpack_public_path__ + "2cb6e383c25eae5a095c977bc1c7b745.svg";